import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getRemoteConfig } from 'firebase/remote-config';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getPerformance } from 'firebase/performance';
import { getMessaging } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyB0ilz3zVM4eSJ1gyO-oPL7zu2L4O4y-9E',
  authDomain: 'usenode.com',
  projectId: 'node-canada',
  databaseURL: 'https://node-canada-default-rtdb.firebaseio.com',
  storageBucket: 'node-canada.appspot.com',
  messagingSenderId: '902440780506',
  appId: '1:902440780506:web:8fc5ad6ff21d4e28b85be3',
};

// firebase.js
export const app = initializeApp(firebaseConfig);
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    '6LenRE8pAAAAAP-t_x4RCYgOKfprwWjzhmpqz3Au'
  ),
  isTokenAutoRefreshEnabled: true,
});
export const messaging = getMessaging(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export const auth = getAuth(app);
export const perf = getPerformance(app);
export const signIn = signInWithEmailAndPassword;
export const remoteConfig = getRemoteConfig(app);
export const storage = getStorage(app);
